<template>
	<div id="footer">
		<div class="good-service-wrapper">
			<good-service :good-service-info="goodServiceInfo" class="good-service">
			</good-service>
		</div>
		<div class="footer-info-container">
			<ul class="footer-info">
				<li v-for="(info,index) in footerInfo" :key="index">
					<p>{{ info.title }}</p>
					<ul class="footer-items">
						<li v-for="(item,key1) in info.items" :key="key1">
							<span>{{ item }}</span>
						</li>
					</ul>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>

	export default {
		name: 'AppFooter',
		components: {
		},
		data() {
			return {
				goodServiceInfo: {
					titleColor: 'rgba(18,171,52)',
					contentColor: 'rgba(18,171,52,0.6)',
					iconSuffix: '-active',
				},
				footerInfo: [
					{
						title: '购物指南',
						items: ['购物流程', '支付方式', '售后服务'],
					},
					{
						title: '配送方式',
						items: ['配送运费', '配送范围', '配送时间'],
					},
					{
						title: '商家服务',
						items: ['平台规则', '商家入驻', '联系我们'],
					},
					{
						title: '联系客服',
						items: ['在线客服', '致电客服', '邮箱反馈'],
					},
				],
			}
		}
	};
</script>

<style scoped>
	#footer {
		width: 100%;
		min-height: 300px;
		height: auto;
	}

	#footer .good-service-wrapper {
		width: 100%;
		height: 100px;
		background-color: #eee;
	}

	#footer .good-service-wrapper .good-service {
		width: 100%;
		max-width: 1200px;
		height: 100%;
		margin: 0 auto;
		padding: 0 var(--page-gutter);
		box-sizing: border-box;
	}

	/* 底部信息部分 */
	#footer .footer-info-container {
		width: 100%;
		height: 200px;
		background: url('../assets/app-footer/app-footer-bg.jpg') no-repeat;
		background-size: 2000px;
		background-position: 50% 0;
		color: #fff;
	}

	#footer .footer-info-container ul.footer-info {
		width: 100%;
		max-width: 800px;
		margin: 0 auto;
		padding: 30px var(--page-gutter);
		line-height: 36px;
		display: flex;
		flex-wrap: wrap;
		box-sizing: border-box;
	}

	#footer .footer-info-container ul.footer-info>li {
		width: 50%;
		margin: 0 auto;
		float: none;
		box-sizing: border-box;
		padding-left: 16px;
	}

	@media (min-width: 768px) {
		#footer .footer-info-container ul.footer-info>li {
			width: 25%;
			padding-left: 60px;
		}
	}

	#footer .footer-info-container ul.footer-info>li p {
		font-size: 22px;
	}

	#footer .footer-info-container ul.footer-info>li ul.footer-items {}

	#footer .footer-info-container ul.footer-info>li ul.footer-items>li span {
		opacity: 0.5;
		font-size: 14px;
		cursor: pointer;
	}

	#footer .footer-info-container ul.footer-info>li ul.footer-items>li span:hover {
		opacity: 1;
	}
</style>



// WEBPACK FOOTER //
// src/components/AppFooter.vue